<div class="snackbar-content">
  <mat-icon>{{ data.icon }}</mat-icon>
  <div class="snackbar-title">{{ data.title }}</div>
  <p class="snackbar-message">{{ data.message }}</p>
  <!--<ul>
    <li *ngFor="let item of data.items">{{ item }}</li>
  </ul>-->
</div>
